<template>
  <NuxtLayout>
    <NuxtPage></NuxtPage>
    <Toaster
      class="pointer-events-auto"
      richColors
      :position="isMobile ? 'top-right' : 'bottom-right'"
    />
    <ConsentBanner v-if="offlineMode == '0'" />
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { Toaster } from '@/components/ui/sonner';
const isMobile = window.innerWidth <= 768;

const config = useRuntimeConfig();
const offlineMode = config.public.OFFLINE_MODE;
const analyticsMsClarity = config.public.ANALYTICS_MS_CLARITY_ID;

const scriptElements: any = [];

if (offlineMode == '0') {
  signalClarity(useConsent().choice.value ?? 'denied');
  scriptElements.push({
    type: 'text/javascript',
    textContent: `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, "clarity", "script", "${analyticsMsClarity}");`,
  });

  // If we are on app.xeo.vision domain, we add the SalesViewer script
  if (window.location.hostname === 'app.xeo.vision') {
    scriptElements.push({
      type: 'text/javascript',
      textContent: `!(function (s, a, l, e, sv, i, ew, er) {try {(a =s[a] || s[l] || function () {throw 'no_xhr';}),(sv = i = 'https://salesviewer.org'),(ew = function(x){(s = new Image()), (s.src = 'https://salesviewer.org/tle.gif?sva=e6d4S3H0p4o0&u='+encodeURIComponent(window.location)+'&e=' + encodeURIComponent(x))}),(l = s.SV_XHR = function (d) {return ((er = new a()),(er.onerror = function () {if (sv != i) return ew('load_err');(sv = 'https://www.salesviewer.com/t'), setTimeout(l.bind(null, d), 0);}),(er.onload = function () {(s.execScript || s.eval).call(er, er.responseText);}),er.open('POST', sv, !0),(er.withCredentials = true),er.send(d),er);}),l('h_json=' + 1 * ('JSON' in s && void 0 !== JSON.parse) + '&h_wc=1&h_event=' + 1 * ('addEventListener' in s) + '&sva=' + e);} catch (x) {ew(x)}})(window, 'XDomainRequest', 'XMLHttpRequest', 'e6d4S3H0p4o0');`,
    });
  }
}

scriptElements.push({
  src: 'https://js.stripe.com/v3/pricing-table.js',
  async: true,
});

scriptElements.push({
  src: 'https://js.live.net/v7.2/OneDrive.js',
  async: false,
});

useHead({
  title: 'XeoVision',
  link: [{ rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }],
  script: scriptElements,
});
</script>
